import { useNavigate } from "react-router-dom"
import BlueTableHeading from "../../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import GeneralBackButton from "../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import GrayDivider from "../../../../common/AdminCommonComponents/GrayDivider/GrayDivider"
import LightGrayBgWrapper from "../../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge"

const SellerDetails = () => {

  const navigate = useNavigate()

  const actions = [
    { label: 'View Details', action: () => navigate('/user-management/sellers/seller/products') },
    { label: 'Edit', action: () => console.log('') },
    { label: 'Delete', action: () => console.log('') },
    { label: 'Change status ', action: () => console.log('') },
  ]

  const tableData = [
    { sr: '1', orderNo: '#1234', customerName: 'Maheen', phone: '03412302789', orderStatus: 'Delivered', payment: '$40' },
    { sr: '2', orderNo: '#1234', customerName: 'Raza', phone: '03412302789', orderStatus: 'Pending', payment: '$40' },
    { sr: '3', orderNo: '#1234', customerName: 'Maheen', phone: '03412302789', orderStatus: 'Delivered', payment: '$40' },
    { sr: '4', orderNo: '#1234', customerName: 'Raza', phone: '03412302789', orderStatus: 'Pending', payment: '$40' },
    { sr: '5', orderNo: '#1234', customerName: 'Raza', phone: '03412302789', orderStatus: 'Pending', payment: '$40' },
  ]

  const columns = [
    {
      name: 'SR #',
      selector: row => row.sr,
      sortable: true,
      grow: 0.5
    },
    {
      name: 'Order No',
      selector: row => row.orderNo,
      sortable: true,
    },
    {
      name: 'Customer Name',
      selector: row => row.customerName,
      sortable: true,
    },
    {
      name: 'Phone',
      selector: row => row.phone,
      sortable: true,
    },
    {
      name: 'Order Status',
      selector: row => row.orderStatus,
      sortable: true,
      cell: row => <StatusBadge statusName={row.orderStatus} />,
    },
    {
      name: 'Payment',
      selector: row => row.payment,
      sortable: true,
    },
    {
      name: 'Actions',
      cell: () => <ActionButton options={actions} />,
      center: "true",
      button: true
    }
  ];
  
  


  return (
    <LightGrayBgWrapper>
      <div className="p-3 shadow bg-white">
        <GeneralBackButton />

        <div className="fw-semibold fs-5 d-flex align-items-center gap-3 mt-3">
          <div>Seller: Mohsin Khan</div>
          <div>ID: 8</div>
        </div>

        <BlueTableHeading className='fw-semibold fs-5'>Orders: 0</BlueTableHeading>

        <div className="my-3"> 
          <GrayDivider />
        </div>

        <DynamicDatatable columns={columns} data={tableData} pagination type='gray' />
      </div>
    </LightGrayBgWrapper>
  )
}

export default SellerDetails
